import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HoverDirective } from '../../directives/hover.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ImageModule } from 'primeng/image';
import { BadgeModule } from 'primeng/badge';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { PageNotFoundComponent } from './pagenotfound/page-not-found.component';
import { LetDirective } from '@ngrx/component';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@NgModule({
    declarations: [NavbarComponent, SidebarComponent, HoverDirective, PageNotFoundComponent],
    exports: [SidebarComponent, NavbarComponent, PageNotFoundComponent],
    imports: [CommonModule, FontAwesomeModule, ImageModule, BadgeModule, TranslateModule, RouterLink, LetDirective, AvatarModule, AvatarGroupModule]
})
export class CoreModule {}
